import type { ApiFieldErrors } from '../types/phoneNumber.types'

/**
 * Formats a DRF-style field-error map into a human-readable string
 * suitable for toast descriptions.
 *
 * Example input:  { number: ["This field must be unique."] }
 * Example output: "number: This field must be unique."
 */
export function formatApiFieldErrors(
  errors?: ApiFieldErrors,
): string | undefined {
  if (!errors || typeof errors !== 'object') return undefined
  const lines: string[] = []
  for (const [field, messages] of Object.entries(errors)) {
    if (Array.isArray(messages)) {
      lines.push(`${field}: ${messages.join(', ')}`)
    } else if (typeof messages === 'string') {
      lines.push(`${field}: ${messages}`)
    }
  }
  return lines.length > 0 ? lines.join('\n') : undefined
}
